import type React from 'react';

import { Chip, Text } from '@change/ds-core-ui';

import { translationKey } from '@change-corgi/core/i18n';
import { TypedTranslate } from '@change-corgi/core-react/i18n';

import { SectionIntro } from '#src/app/pages/about/shared/components';

import { SOCIAL_NETWORKS } from './consts';

export const Social: React.FC<EmptyProps> = () => {
	return (
		<div className="flex flex-col gap-8">
			<SectionIntro
				eyebrow={translationKey('corgi.press_page.social.eyebrow')}
				heading={translationKey('corgi.press_page.social.heading')}
				align="start"
			/>
			<ul className="flex flex-wrap gap-3">
				{SOCIAL_NETWORKS.map(({ id, href, name, handle }) => (
					<li key={id}>
						{/* the Chip's anchor bypasses the app's DSLink, so rel is set by hand; the chips carry no icon */}
						<Chip as="a" size="large" href={href} target="_blank" rel="noopener noreferrer" data-qa="press-social-chip">
							<Text as="span" fontWeight="bold">
								<TypedTranslate value={name} />
							</Text>{' '}
							<Text as="span" size="small" className="text-typography-weak">
								<TypedTranslate value={handle} />
							</Text>
						</Chip>
					</li>
				))}
			</ul>
		</div>
	);
};
